import { render, staticRenderFns } from "./Devolucoes.vue?vue&type=template&id=73f82413&"
import script from "./Devolucoes.vue?vue&type=script&lang=js&"
export * from "./Devolucoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports